import { Outlet } from "react-router";
import TeacherPortalLearningMaterialTable from "./table/LearningMaterialsTable";

const TeacherPortalLearningMaterials = ({ activitiesWithUsageData, course }) => (
    <>
        <div className="grid grid-cols-1 gap-8">
            <section className="rounded bg-card shadow-default">
                <header className="px-4 pt-4"><h2 className="text-xl font-semibold">Learning Materials</h2></header>
                <div className="p-4"><TeacherPortalLearningMaterialTable activitiesWithUsageData={activitiesWithUsageData} /></div>
            </section>
        </div>
        <Outlet />
    </>
);

export default TeacherPortalLearningMaterials;
